<template>
  <div
    class="settings-loader"
    :class="{
      'settings-loader--loading': loading,
      'settings-loader--error': !loading && errorMessage
    }"
    v-if="message"
  >
    <span>
      {{ message }}
    </span>
  </div>
</template>

<script>
export default {
  name: "SettingsLoader",
  props: {
    loading: { type: Boolean },
    errorMessage: { type: String, default: "" }
  },
  computed: {
    message() {
      if (this.loading) {
        return this.$t("loading")
      } else if (!this.loading && this.errorMessage) {
        return this.errorMessage
      } else {
        return null
      }
    }
  },
  i18n: {
    messages: {
      en: { loading: "Loading..." },
      de: { loading: "Lade..." }
    }
  }
}
</script>

<style lang="scss">
.settings-loader {
  margin-top: $basex3;
  margin-bottom: $basex3;

  text-align: center;
}
</style>
